<template>
  <div id="mapcontainer" class="mapcontainer">
    <div v-if="moveBlocker" class="moveBlocker"></div>

    <img id="headerForfourth" src="/headerForfourth.jpg" class="imgForPdf" />
    <img id="header1" src="/header1.jpg" class="imgForPdf" />
    <img id="gps" src="/gps.jpg" class="imgForPdf" />
    <img id="scheduleButton" src="/button.jpg" class="imgForPdf" />
    <img id="fifthPage" src="/fifthPage.jpg" class="imgForPdf" />
    <img id="sjLogo" src="/sjLogo.jpg" class="imgForPdf" />
    <img id="applybtn" src="/button.jpg" class="imgForPdf" />
    <img id="speaker" src="/speaker.jpg" class="imgForPdf" />
    <img id="sixthPage" src="/sixthPage.jpg" class="imgForPdf" />
    <img
      id="styleImage"
      :src="'./style/' + styleOfFence + '.jpg'"
      onError="this.src = './style/Style.jpg'"
      class="imgForPdf"
    />
    <img id="defaultStyleImage" src="/style/Style.jpg" class="imgForPdf" />

    <div id="htmltocanvas">
      <div v-if="moveVis" class="googleMap" id="googleMap"></div>
      <div
        v-if="mobileClick"
        v-touch:start="drawTouch"
        v-touch:end="drawTouch"
        class="googleMap"
        id="googleMap"
      ></div>
      <div
        v-if="desktopClick"
        @mousedown="drawTouch"
        class="googleMap"
        id="googleMap"
      ></div>
      <div id="lengthSetter"></div>
      <div id="cornerSetter"></div>
      <div id="lineSetter"></div>
    </div>

    <div v-show="moveVis">
      <div
        data-html2canvas-ignore="true"
        v-show="sidepanel"
        class="padWrapper z-index-two"
        :style="{ right: padWrapperRight }"
      >
        <nav class="d-pad" id="d-pad">
          <img src="/whiteArrow.png" class="up" href="#" />
          <img src="/whiteArrow.png" class="right" href="#" />
          <img src="/whiteArrow.png" class="down" href="#" />
          <img src="/whiteArrow.png" class="left" href="#" />
          <div class="centerCircle"></div>
        </nav>
      </div>
      <div
        data-html2canvas-ignore="true"
        v-show="sidepanel"
        id="zoomPadWrapper"
        class="zoomPadWrapper z-index-two"
        :style="{ right: zoomPadWrapperRight }"
      >
        <nav class="zoom-pad">
          <img src="/zoomIn.png" class="zoomIn" href="#" />
          <img src="/zoomOut.png" class="zoomOut" href="#" />
        </nav>
      </div>
    </div>
    <div
      data-html2canvas-ignore="true"
      v-show="showUndo"
      class="UndoWrapper z-index-two"
    >
      <button v-on:click="deleteSelectedShape()" class="undobutton">
        Undo Segment
      </button>
    </div>
    <div
      v-bind:key="user.id"
      v-for="user in userData"
      class="floating-panel"
      id="floating-panel"
      v-show="showLocate"
    >
      <form @submit.prevent="starttut" id="enteraddress" class="enteraddress">
        <label for="address">Enter Your Address</label><br />
        <input
          class="addressBox"
          type="text"
          name="homeAddress"
          id="address"
          v-model="user.homeAddress"
        /><br />
        <input
          type="submit"
          value="Locate"
          name="submitaddress"
          id="submitaddress"
        />
      </form>
    </div>

    <div v-show="sidepanel" data-html2canvas-ignore="true">
      <div class="sideCheckbox">
        <input
          id="menu__toggle"
          @click="showToggle = !showToggle"
          type="checkbox"
        />
        <label class="menu__btn" for="menu__toggle">
          <span></span>
        </label>
      </div>
      <div v-show="showToggle" :class="sidepanelClass">
        <div class="">
          <div class="nav-toggle"></div>
          <p ref="printMe" id="tutorialstep" class="tutorialstep">
            {{
              isMobile == true
                ? "Drag so you can see you your property."
                : "Position the map using controls at the bottom right."
            }}
          </p>
          <!-- Draw your fence using the mouse -->
          <button v-show="moveVis" v-on:click="startDrawingFence()">
            Done Moving Map
          </button>
          <button v-show="finishVis" v-on:click="finishFenceSwitch()">
            Done Drawing Fence
          </button>

          <select
            style="margin-top: 15px !important"
            v-model="categoryOfFence"
            @click="displayStyleWhenClick"
            v-show="chooseCategory"
          >
            <option selected disabled>Category</option>
            <option
              v-bind:key="fencePricing.Category"
              v-for="fencePricing in fenceR"
            >
              {{ fencePricing }}
            </option>
          </select>

          <div v-show="chooseStyle" class="fenceStyleWrapperWrap">
            <div
              class="fenceStyleWrapper"
              v-bind:key="fencePricing.style"
              v-for="fencePricing in fenceCategoryForStyle"
            >
              <input
                style="opacity: 0"
                type="radio"
                :id="fencePricing.style"
                :value="fencePricing.style"
                v-model="styleOfFence"
                @click="selectStyleWhenClick"
              />
              <label class="fenceStyleLabel" :for="fencePricing.style"
                >{{ fencePricing.style }}<br />
                <img
                  class="fenceStylePhoto"
                  :id="fencePricing.style"
                  :src="fencePricing.photo"
              /></label>
            </div>
          </div>

          <select class="whatStyle" disabled v-show="chooseHeight">
            <option selected disabled>
              Selected style: {{ this.styleOfFence }}
            </option>
          </select>

          <select
            v-model="heightOfFenceHolder"
            @click="displayColorWhenClick"
            v-show="chooseHeight"
          >
            <option selected disabled>Height</option>
            <option
              v-bind:key="fencePricing.Category"
              v-for="fencePricing in fenceStyleForHeight"
            >
              <p>{{ fencePricing }}"</p>
            </option>
          </select>

          <div v-show="chooseColor" class="fenceStyleWrapperWrap">
            <div
              class="fenceStyleWrapper"
              v-bind:key="fenceColors.category"
              v-for="fenceColors in fenceStyleForColor"
            >
              <input
                style="opacity: 0"
                type="radio"
                :id="fenceColors.color"
                :value="fenceColors.color"
                v-model="colorOfFence"
                @click="selectColorWhenClick"
              />
              <label class="fenceStyleLabel" :for="fenceColors.color"
                >{{ fenceColors.color }}<br />
                <img
                  class="fenceStylePhoto"
                  :id="fenceColors.color"
                  :src="fenceColors.photo"
              /></label>
            </div>
          </div>

          <select class="whatStyle" disabled v-show="fenceFormDisabled">
            <option selected disabled>
              Selected color: {{ this.colorOfFence }}
            </option>
          </select>

          <select
            v-model="capStyle"
            id="capData"
            class="capInput"
            v-if="categoryOfFence == 'Vinyl'"
            v-show="capStyle != 'Which Style Cap'"
          >
            <option selected disabled>Which Style Cap</option>
            <option
              v-bind:key="fenceCaps.category"
              v-for="fenceCaps in fenceStyleForCap"
            >
              <p>{{ fenceCaps["Cap Style"] }}</p>
            </option>
          </select>

          <div
            v-if="categoryOfFence == 'Vinyl'"
            v-show="chooseCapQuestion"
            class="fenceStyleWrapperWrap"
          >
            <div
              class="fenceStyleWrapper"
              :disabled="fenceFormDisabled == 1"
              v-bind:key="fenceCaps['Cap Style']"
              v-for="fenceCaps in fenceStyleForCap"
            >
              <input
                style="opacity: 0"
                type="radio"
                :id="fenceCaps['Cap Style']"
                :value="fenceCaps['Cap Style']"
                v-model="capStyle"
              />
              <label class="fenceStyleLabel" :for="fenceCaps['Cap Style']"
                >{{ fenceCaps["Cap Style"] }}<br />
                <div v-if="fenceCaps['Cap Style'] == 'Gothic Cap'">
                  <img
                    class="fenceStylePhoto"
                    style="margin-top: 15px !important"
                    :src="fenceCaps.photo"
                  />
                </div>
                <div v-else-if="fenceCaps['Cap Style'] == 'Federation Cap'">
                  <img
                    class="fenceStylePhoto"
                    style="margin-top: 15px !important"
                    :src="fenceCaps.photo"
                  />
                </div>
                <div v-else>
                  <img class="fenceStylePhoto" :src="fenceCaps.photo" />
                </div>
              </label>
            </div>
          </div>

          <h3
            v-show="chooseGateQuestion"
            style="padding: 10px 0px 0px 0px !important"
          >
            Add A Gate?
          </h3>
          <button v-show="chooseGateQuestion" v-on:click="makeAGate()" style="">
            Yes</button
          >&nbsp;<button
            v-on:click="noGate()"
            v-show="chooseGateQuestion"
            style=""
          >
            No
          </button>

          <h3 v-show="chooseGate" style="padding: 10px 0px !important">
            Choose Your Gate Style
          </h3>

          <select id="gateStyleInupt" v-model="gateStyle" v-show="chooseGate">
            <option selected disabled>Gate</option>
            <option>
              <p>3' Gate</p>
            </option>
            <option>
              <p>4' Gate</p>
            </option>
            <option>
              <p>5' Gate</p>
            </option>
            <option>
              <p>6' Double Gate</p>
            </option>
            <option>
              <p>8' Double Gate</p>
            </option>
            <option>
              <p>10' Double Gate</p>
            </option>
          </select>

          <h4 v-show="chooseSide" style="padding: 10px 0px 10px 0px !important">
            What side will your gate be on?
          </h4>

          <p
            v-show="chooseSideSubTxt"
            style="padding: 5px 10px 10px 10px !important; font-size: 14px"
          >
            If there are two values that are alike-- the sides are listed in the
            order of which they were drawn.
          </p>

          <select v-model="gateSide" v-show="chooseSide">
            <option selected disabled>Which Side</option>
            <option
              v-bind:key="lengths.category"
              v-for="(lengths, index) in lengths"
            >
              <span style="color: red !important">{{ index + 1 }}: </span>
              <p>{{ lengths }}</p>
            </option>
          </select>

          <h4 v-show="chooseFeetFrom" style="padding: 10px 0px !important">
            How many feet from the<br />
            end of that side will your gate be?
          </h4>
          <input
            v-show="chooseFeetFrom"
            v-model.number="feetFrom"
            type="number"
            id="feetFrom"
            name="feetFrom"
          />

          <button v-on:click="lengthFromEndChoosen" v-show="chooseFeetFrom">
            Done
          </button>

          <h4 v-show="whichDirection" style="padding: 10px 0px !important">
            From which end of that length<br />
            of fence?
          </h4>

          <select v-model="gateFromSide" v-show="whichDirection">
            <option selected disabled>From Which End</option>
            <option>
              <p>North</p>
            </option>
            <option>
              <p>North East</p>
            </option>
            <option>
              <p>East</p>
            </option>
            <option>
              <p>South East</p>
            </option>
            <option>
              <p>South</p>
            </option>
            <option>
              <p>South West</p>
            </option>
            <option>
              <p>West</p>
            </option>
            <option>
              <p>North West</p>
            </option>
          </select>

          <button v-show="fenceAdd" v-on:click="addFence()">
            Add Another Fence
          </button>
          <button v-show="gateDialog" v-on:click="addAnotherGate()">
            Add Another Gate
          </button>
          <button v-show="gateDialog" v-on:click="finishGate()">Finish</button>

          <div id="removalData" class="removalInput" v-show="showRemoval">
            <p>How many of removal?</p>

            <button
              class="removalButton"
              v-on:click="amountOfRemovalAll()"
              value="0"
            >
              All
            </button>
            <input
              type="number"
              v-model="amountOfRemoval"
              style="width: 50%"
              value="0"
            />
          </div>

          <div v-show="this.amountOfRemoval > 0">
            <p style="margin-top: 15px !important">
              Please select removal Category
            </p>
            <select
              style="margin-top: 15px !important"
              v-model="removalCategory"
            >
              <option selected disabled>Category</option>
              <option
                v-bind:key="fencePricing.Category"
                v-for="fencePricing in fenceRemovalCategory"
              >
                {{ fencePricing }}
              </option>
            </select>
          </div>

          <div
            style="padding-top: 10px !important"
            id="holesData"
            class="holesInput"
            v-show="showRemoval"
          >
            <div
              style="
                width: 190px;
                text-align: center;
                margin: 0px auto !important;
                display: block;
              "
            >
              <p style="float: left">How many hard holes?</p>
              <img
                v-on:mouseover="showToolTip = true"
                v-on:mouseleave="showToolTip = false"
                style="
                  cursor: pointer;
                  width: 14px;
                  height: auto;
                  float: left;
                  margin-left: 5px !important;
                  background-color: rgb(40, 122, 204);
                  border-radius: 100px;
                  padding: 2px !important;
                "
                src="/interface.png"
              />
              <div
                style="margin-bottom: -142px !important"
                class="holesToolTip"
                v-if="showToolTip"
              >
                A hard hole is any post that is going into concrete, asphalt or
                pavers. If you are unsure please enter 0.
              </div>
            </div>
            <input
              v-model.number="amountOfHoles"
              style="width: 80%"
              value="0"
            />
          </div>
          <button v-show="calculateButton" v-on:click="doneFence()">
            Calculate
          </button>

          <div
            style="padding-top: 10px !important"
            id="holesData"
            class="holesInput"
            v-show="submitForEstimate"
            v-if="this.adminId == 1"
          >
            <div
              style="
                width: 100%;
                text-align: center;
                margin: 0px auto !important;
                display: block;
              "
            >
              <!-- <p>Minimum Profit?</p> -->
              <div
                style="margin-bottom: -142px !important"
                class="holesToolTip"
                v-if="showToolTip"
              >
                A hard hole is any post that is going into concrete, asphalt or
                pavers. If you are unsure please enter 0.
              </div>
            </div>
          </div>

          <estimateButtonMember
            :disabled="estimatebuttonsdisabled == 1"
            @response="(msg) => (customerPDF = msg)"
            v-bind:fenceAdd="fenceAdd"
            v-bind:multiFences="multiFences"
            v-on:loadingYes="loadingYes"
            v-on:removalNoCategory="removalNoCategory"
            v-on:loadingNo="loadingNo"
            v-bind:chargeMd="chargeMd"
            v-bind:scheduleButton="scheduleButton"
            v-bind:fifthPage="fifthPage"
            v-bind:speaker="speaker"
            v-bind:sixthPage="sixthPage"
            v-bind:sjLogo="sjLogo"
            v-bind:applybtn="applybtn"
            v-bind:currentZipcodes="currentZipcodes"
            v-bind:isMobile="isMobile"
            v-bind:isTablet="isTablet"
            v-bind:companies="companies"
            v-bind:removalCategory="removalCategory"
            v-bind:userData="userData"
            v-bind:categoryOfFence="categoryOfFence"
            v-bind:styleOfFence="styleOfFence"
            v-bind:heightOfFence="heightOfFence"
            v-bind:colorOfFence="colorOfFence"
            v-bind:gateStyle="gateStyle"
            v-bind:gateWidth="gateWidth"
            v-bind:lengths="lengths"
            v-bind:fencePricing="fencePricing"
            v-bind:removalDbSource="removalDbSource"
            v-bind:amountOfRemoval="amountOfRemoval"
            v-bind:output="output"
            v-bind:styleImage="styleImage"
            v-bind:fenceImg="fenceImg"
            v-bind:headerone="headerone"
            v-bind:gps="gps"
            v-bind:headerForfourth="headerForfourth"
            v-bind:fencePhoto="fencePhoto"
            v-bind:gates="gates"
            v-bind:amountOfCorners="amountOfCorners"
            v-bind:capStyle="capStyle"
            v-bind:extraPanelData="extraPanelData"
            v-bind:fenceCapStyle="fenceCapStyle"
            v-bind:cornersArray="cornersArray"
            v-bind:feetFromZero="feetFromZero"
            v-bind:amountOfHoles="amountOfHoles"
            v-if="adminId == 1"
            v-show="submitForEstimate"
          />

          <div v-if="loading" class="loader">Calculating. Please Wait...</div>

          <button
            v-if="!isMobile"
            style="
              padding-top: 4px !important;
              bottom: 10px !important;
              position: absolute !important;
              right: 30px;
            "
          >
            <a
              style="text-decoration: none; color: white; font-size: 12px"
              href="https://sjfencesupply.com/"
              >Back To SJFenceSupply.com</a
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://code.jquery.com/jquery-3.4.1.js"></script>
<script
  type="text/javascript"
  src="https://reportallusa.com/overlay/js.php?v=3&map=Google&client=OgwRmVYOdo"
></script>
<script src="https://kit.fontawesome.com/a076d05399.js"></script>

<script>
import estimateButtonMember from "./estimateButtonMember.vue";
import { isMobile, isTablet, deviceType } from "mobile-device-detect";
import emailjs from "@emailjs/browser";
import axios from "axios";
import { db } from "../assets/db.js";
import geo2zip from "geo2zip";
import { Base64 } from "js-base64";
import {
  doc,
  getDoc,
  query,
  collection,
  where,
  onSnapshot,
  getDocs,
} from "firebase/firestore";

export default {
  name: "googleMap",
  props: [
    "reset",
    "companyLogo",
    "adminUserData",
    "toEmail",
    "userData",
    "showLocate",
    "fencelengths",
    "fencePricing",
    "removalDbSource",
    "fenceCapStyle",
    "extraPanelData",
    "adminId",
    "propertyLinesValue",
    "chargeMd",
  ],
  components: {
    estimateButtonMember,
  },
  mounted() {
    initMap();
    drawingManager.setDrawingMode(null);
    // get Database
  },
  created() {
    if (isMobile == true) {
      this.isTablet = isTablet;
      this.isMobile = true;
      this.sidepanelClass = "sidepanelWithoutBackground z-index-two";
      this.padWrapperRight = "100px";
      this.zoomPadWrapperRight = "180px";
    } else {
      this.isTablet = false;
      this.isMobile = false;
      this.sidepanelClass = "sidepanel z-index-two";
      this.padWrapperRight = "360px";
      this.zoomPadWrapperRight = "430px";
    }
  },
  data() {
    return {
      fenceRemovalCategory: [
        "Aluminum",
        "Chain Link",
        "Split Rail",
        "Split Rail with Wire",
        "Vinyl",
        "Wood",
      ],
      colorLines: [],
      currentZipcodes: null,
      customerPDF: null,
      companies: [],
      isTablet: false,
      moveBlockerColor: "blur(0px)",
      gothicCap: null,
      padWrapperRight: null,
      zoomPadWrapperRight: null,
      scheduleButton: null,
      sidepanelClass: null,
      isMobile: false,
      showToggle: true,
      fifthPage: null,
      speaker: null,
      sixthPage: null,
      sjLogo: null,
      applybtn: null,
      firstPoint: null,
      mouseMove: false,
      removalCategory: null,
      showRemoval: false,
      styleImage: null,
      multiFences: [],
      moveBlocker: false,
      displayGateAfterLoading: false,
      showToolTip: false,
      counter: 0,
      newCounter: 0,
      lengths: [],
      moveVis: true,
      finishVis: false,
      finishFence: false,
      categoryOfFence: "Category",
      styleOfFence: "Style",
      heightOfFence: "Height",
      colorOfFence: "Color",
      gateSide: "Which Side",
      gateStyle: "Gate",
      gateFromSide: "From Which End",
      capStyle: "Which Style Cap",
      feetFrom: 0,
      amountOfRemoval: 0,
      amountOfHoles: 0,
      amountOfCorners: 0,
      chooseCategory: false,
      chooseStyle: false,
      chooseHeight: false,
      chooseColor: false,
      chooseSide: false,
      chooseSideSubTxt: false,
      chooseCornerQuestion: false,
      chooseGateQuestion: false,
      chooseCapQuestion: false,
      chooseGate: false,
      chooseFeetFrom: false,
      fenceFormDisabled: 0,
      buttonIsntActive: 0,
      firstX: null,
      firstY: null,
      secondX: null,
      secondY: null,
      newX: null,
      newY: null,
      tempLength: null,
      whichDirection: null,
      gateDialog: null,
      submitForEstimate: null,
      output: null,
      fenceImg: null,
      headerone: null,
      gps: null,
      headerForfourth: null,
      gates: [],
      cornersArray: [],
      lastSegmentWasACorner: false,
      eitherEndsCorner: false,
      anotherCounter: false,
      gateExists: false,
      loading: false,
      estimatebuttonsdisabled: 1,
      sidepanel: false,
      heightOfFenceHolder: "Height",
      feetFromZero: 0,
      showUndoButton: false,
      fencePhoto: this.fenceStyleForPhoto,
      fenceAdd: false,
      calculateButton: false,
    };
  },
  watch: {
    reset() {
      // initial
      this.colorLines = [];
      this.currentZipcodes = null;
      this.customerPDF = null;
      this.moveBlockerColor = "blur(0px)";
      this.gothicCap = null;
      this.showToggle = true;
      this.firstPoint = null;
      this.mouseMove = false;
      this.removalCategory = null;
      this.showRemoval = false;
      this.styleImage = null;
      this.multiFences = [];
      this.moveBlocker = false;
      this.displayGateAfterLoading = false;
      this.showToolTip = false;
      this.counter = 0;
      this.newCounter = 0;
      this.lengths = [];
      this.moveVis = true;
      this.finishVis = false;
      this.finishFence = false;
      this.categoryOfFence = "Category";
      this.styleOfFence = "Style";
      this.heightOfFence = "Height";
      this.colorOfFence = "Color";
      this.gateSide = "Which Side";
      this.gateStyle = "Gate";
      this.gateFromSide = "From Which End";
      this.capStyle = "Which Style Cap";
      this.feetFrom = 0;
      this.amountOfRemoval = 0;
      this.amountOfHoles = 0;
      this.amountOfCorners = 0;
      this.chooseCategory = false;
      this.chooseStyle = false;
      this.chooseHeight = false;
      this.chooseColor = false;
      this.chooseSide = false;
      this.chooseSideSubTxt = false;
      this.chooseCornerQuestion = false;
      this.chooseGateQuestion = false;
      this.chooseCapQuestion = false;
      this.chooseGate = false;
      this.chooseFeetFrom = false;
      this.fenceFormDisabled = 0;
      this.buttonIsntActive = 0;
      this.firstX = null;
      this.firstY = null;
      this.secondX = null;
      this.secondY = null;
      this.newX = null;
      this.newY = null;
      this.tempLength = null;
      this.whichDirection = null;
      this.gateDialog = null;
      this.submitForEstimate = null;
      this.gates = [];
      this.cornersArray = [];
      this.lastSegmentWasACorner = false;
      this.eitherEndsCorner = false;
      this.anotherCounter = false;
      this.gateExists = false;
      this.loading = false;
      this.estimatebuttonsdisabled = 1;
      this.heightOfFenceHolder = "Height";
      this.feetFromZero = 0;
      this.showUndoButton = false;
      this.fencePhoto = this.fenceStyleForPhoto;
      this.fenceAdd = false;
      this.calculateButton = false;
    },
    async sidepanel() {
      const address = this.userData[0].homeAddress;
      const locationAddress = address.split(",");
      const isUsa = locationAddress[locationAddress.length - 1];
      const self = this;

      let geocoder = new google.maps.Geocoder();
      let companies = [];

      const queryUsers = await getDocs(collection(db, "users"));
      const queryProducts = await getDocs(collection(db, "products"));

      const isValidZipForUSA = (counties) => {
        let flag = false;

        for (const key in counties) {
          counties[key].map((county) => {
            this.currentZipcodes.map((usaZip) => {
              if (county.id == usaZip) {
                flag = true;
              }
            });
          });
        }
        return flag;
      };

      if (isUsa == " USA") {
        // get lat and lon

        geocoder.geocode(
          { address: address },
          async function (results, status) {
            if (status === "OK") {
              const location = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng(),
              };
              self.currentZipcodes = await geo2zip(location, {
                limit: 5,
              }).then((raw) => raw);
              // filter usa companies

              queryUsers.forEach((doc) => {
                if (doc.data().active == true && doc.data().role != "admin") {
                  queryProducts.forEach((docP) => {
                    if (doc.id == docP.id) {
                      // check to have custom zip
                      if (isValidZipForUSA(docP.data().zipCode) == true) {
                        const info = {
                          id: docP.id,
                          name: doc.data().name,
                          email: doc.data().mail,
                          post: 0,
                          labor: 0,
                          phone: doc.data().phone,
                          removal: 0,
                          ...docP.data(),
                        };
                        companies.push(info);
                      }
                    }
                  });
                }
              });
            }
          }
        );
      } else {
        queryUsers.forEach((doc) => {
          if (doc.data().active == true && doc.data().role != "admin") {
            queryProducts.forEach((docP) => {
              if (doc.id == docP.id) {
                const info = {
                  id: docP.id,
                  name: doc.data().name,
                  email: doc.data().mail,
                  post: 0,
                  labor: 0,
                  phone: doc.data().phone,
                  removal: 0,
                  ...docP.data(),
                };
                companies.push(info);
              }
            });
          }
        });
      }
      this.companies = companies;
    },
    newCounter() {
      if (this.newCounter == 0) {
        this.showUndoButton = false;
      }
    },
    lengths() {
      if (
        this.displayGateAfterLoading == true &&
        this.counter > 2 &&
        this.lengths.length == 1
      ) {
        drawingManager.setDrawingMode("polyline");
      }
    },
    moveVis() {
      if (this.moveVis == true) {
        drawingManager.setDrawingMode(null);
      } else {
        this.moveBlocker = false;
        this.showUndo;
        drawingManager.setDrawingMode("polyline");
      }
    },
    gates() {
      if (this.feetFrom == 0) {
        this.feetFromZero += 1;
      }
    },
    propertyLinesValue() {
      if (this.propertyLinesValue == true) {
        $("#googleMap").css("background-color", "#fff !important");
        $("#googleMap div div div div div div img").css("visibility", "hidden");
      } else if (this.propertyLinesValue == false) {
        $("#googleMap").css("background-color", "");
        $("#googleMap div div div div div div img").css(
          "visibility",
          "visible"
        );
      }
    },
    output() {
      if (this.output != null) {
        this.estimatebuttonsdisabled = 0;
      }
    },
    categoryOfFence() {
      if (this.categoryOfFence != "Category") {
        this.chooseStyle = true;
      }
    },
    async styleOfFence() {
      if (this.styleOfFence != "Style") {
        this.chooseHeight = true;
        this.heightOfFenceHolder = "Height";
        this.chooseStyle = false;
        this.chooseColor = false;
        this.chooseCapQuestion = false;
        this.chooseGateQuestion = false;
        this.fenceFormDisabled = 0;
        this.styleImage = null;

        const options = {
          useCORS: true,
          allowTaint: false,
          ignoreElements: (node) => {
            return node.nodeName === "IFRAME";
          },
        };
        let el2 = document.getElementById("styleImage");
        let defaultStyleImage = document.getElementById("defaultStyleImage");

        this.styleImage = await this.$html2canvas(el2, options);

        if (this.styleImage.width == 32) {
          this.styleImage = await this.$html2canvas(defaultStyleImage, options);
        }
      }
    },
    heightOfFenceHolder() {
      if (this.heightOfFenceHolder != "Height") {
        this.chooseColor = true;
        this.heightOfFence = parseFloat(this.heightOfFenceHolder);
      }
    },
    colorOfFence() {
      if (this.colorOfFence != "Color" && this.categoryOfFence == "Vinyl") {
        this.fenceFormDisabled = 1;
        this.chooseCapQuestion = 1;
        drawingManager.setDrawingMode(null);
      } else if (this.colorOfFence != "Color") {
        this.fenceFormDisabled = 1;
        this.chooseGateQuestion = 1;
        drawingManager.setDrawingMode(null);
      }
      if (
        this.colorOfFence != "Color" &&
        this.categoryOfFence == "Vinyl" &&
        this.fenceStyleForCap.length == 0
      ) {
        this.fenceFormDisabled = 1;
        this.chooseGateQuestion = 1;
        drawingManager.setDrawingMode(null);
      }

      let color = null;

      // set color according to style
      switch (this.colorOfFence) {
        case "Black":
          color = "black";
          break;
        case "White":
          color = "white";
          break;
        case "Green":
          color = "green";
          break;
        case "Grey":
          color = "grey";
          break;
        case "Adobe":
          color = "#8a8a5c";
          break;
        case "Almond":
          color = "#8a8a5c";
          break;
        case "Khaki":
          color = "#8a8a5c";
          break;
        case "Tan":
          color = "#8a8a5c";
          break;
        case "Cedar":
          color = "#ff9900";
          break;
        case "Preasure Treated":
          color = "#ff9900";
          break;

        default:
          break;
      }

      // set color of fence
      this.colorLines.map((id) => {
        $("#" + id).css("background-color", color);
      });
    },
    capStyle() {
      if (this.capStyle != "Which Cap Style") {
        this.chooseGateQuestion = 1;
        drawingManager.setDrawingMode(null);
        this.chooseCapQuestion = false;
      }
    },
    gateStyle() {
      if (this.gateStyle != "Gate") {
        this.chooseSide = true;
        this.chooseSideSubTxt = true;
      }
    },
    gateSide() {
      if (this.gateSide != "Which Side") {
        this.chooseFeetFrom = true;
        this.chooseSideSubTxt = false;
      }
    },
    fenceStyleForPhoto() {
      // If you are loading file from a remote server, be sure to configure “Access-Control-Allow-Origin”
      // For example, the following image can be loaded from anywhere
      var url = this.fenceStyleForPhoto;
      if (url == "") {
        url =
          "http://crazysquirrelsolutions.com/wp-content/FencePricingAssets/FenceStylePhotos/richmond.jpg";
      }
      var urlRe = url.replace(/http/g, "https");
      // Initialize the XMLHttpRequest and wait until file is loaded
      var xhr = new XMLHttpRequest();
      var blob;
      xhr.onload = function () {
        blob = xhr.response;
      };

      // Send HTTP request and fetch file as ArrayBuffer
      xhr.open("GET", urlRe);
      xhr.responseType = "blob";
      xhr.send();

      // Define the FileReader which is able to read the contents of Blob
      var reader = new FileReader();

      // The magic always begins after the Blob is successfully loaded

      var self = this;
      reader.onload = function () {
        // Since it contains the Data URI, we should remove the prefix and keep only Base64 string
        self.fencePhoto = reader.result.replace(/^data:.+;base64,/, "");

        // Decode the Base64 string and show result just to make sure that everything is OK
        // var html = atob(b64);
      };
      setTimeout(function () {
        // Since everything is set up, let’s read the Blob and store the result as Data URI
        reader.readAsDataURL(blob);
      }, 3000);
    },

    placingGate() {
      document
        .getElementById("googleMap")
        .addEventListener("click", function (shape) {
          selectedShape = shape;
          alert(selectedShape);
        });
    },
    async submitForEstimate() {
      if (this.submitForEstimate == 1) {
        const el = document.getElementById("app");
        const sjLogo = document.getElementById("sjLogo");
        const gps = document.getElementById("gps");
        const fifthPage = document.getElementById("fifthPage");
        const speaker = document.getElementById("speaker");
        const applybtn = document.getElementById("applybtn");
        const headerone = document.getElementById("header1");
        const sixthPage = document.getElementById("sixthPage");

        // var styleImage = document.getElementById(this.styleOfFence + ".png");
        // add option type to get the image version
        // if not provided the promise will return
        // the canvas.
        const options = {
          useCORS: true,
          allowTaint: false,
          ignoreElements: (node) => {
            return node.nodeName === "IFRAME";
          },
        };

        this.gps = await this.$html2canvas(gps, options);
        this.speaker = await this.$html2canvas(speaker, options);
        this.sjLogo = await this.$html2canvas(sjLogo, options);
        this.fifthPage = await this.$html2canvas(fifthPage, options);
        this.sixthPage = await this.$html2canvas(sixthPage, options);
        this.headerone = await this.$html2canvas(headerone, options);
        this.applybtn = await this.$html2canvas(applybtn, options);
        this.output = await this.$html2canvas(el, options);
      }
    },
  },
  computed: {
    mobileClick() {
      return !this.moveVis && this.isMobile;
    },
    desktopClick() {
      return !this.moveVis && !this.isMobile;
    },
    showUndo: function () {
      if (this.sidepanel && this.showUndoButton == true) {
        return true;
      } else {
        return false;
      }
    },
    gateWidth: function () {
      var gateWidth = parseFloat(this.gateStyle);
      return gateWidth;
    },
    fenceR: function () {
      let filteredDone = this.fencePricing.map((element) => element.Category);
      let filteredDoneNow = new Set(filteredDone);
      let filterForLength = Array.from(filteredDoneNow);
      return filterForLength;
    },
    fenceCategoryForStyle: function () {
      var array3 = [];
      let setCategory = this.categoryOfFence;
      let filtered = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredDone = filtered.map((element) => element.style);
      let filteredDoneNow = new Set(filteredDone);
      var filteredDoneNowNow = Array.from(filteredDoneNow);
      var array1 = this.fencePricing.filter(function (item) {
        return filteredDoneNowNow.includes(item.style);
      });
      var array2 = array1.map(function (elem) {
        return {
          photo: "./style/" + elem.style + ".jpg",
          style: elem.style,
        };
      });
      var array3 = unique(array2, ["photo", "style"]);

      function unique(arr, keyProps) {
        const kvArray = arr.map((entry) => {
          const key = keyProps.map((k) => entry[k]).join("|");
          return [key, entry];
        });
        const map = new Map(kvArray);
        return Array.from(map.values());
      }
      return array3;
    },
    fenceStyleForPhoto: function () {
      let setStyle = this.styleOfFence;
      let filtered = this.fencePricing.filter(
        (element) => element.style === setStyle
      );
      let filteredDone = filtered.map((element) => element.photo);
      return filteredDone[0];
    },
    fenceStyleForHeight: function () {
      let setCategory = this.categoryOfFence;
      let setStyle = this.styleOfFence;

      let filteredCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filtered = filteredCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredDone = filtered.map((element) => element.height);
      let filteredDoneNow = new Set(filteredDone);
      return filteredDoneNow;
    },
    fenceStyleForColor: function () {
      var array3 = [];
      let setCategory = this.categoryOfFence;
      let setStyle = this.styleOfFence;
      let filtered = this.fencePricing.filter(
        (element) => element.style === setStyle
      );
      let filteredAgain = filtered.filter(
        (element) => element.Category === setCategory
      );
      let filteredDone = filteredAgain.map((element) => element.Color);
      let filteredDoneNow = new Set(filteredDone);
      var array1 = Array.from(filteredDoneNow);
      var array2 = array1.map(function (elem) {
        return {
          photo: "./color/" + elem + ".jpg",
          color: elem,
        };
      });

      var array3 = unique(array2, ["photo", "color"]);

      function unique(arr, keyProps) {
        const kvArray = arr.map((entry) => {
          const key = keyProps.map((k) => entry[k]).join("|");
          return [key, entry];
        });
        const map = new Map(kvArray);
        return Array.from(map.values());
      }
      return array3;
    },
    fenceStyleForGate: function () {
      // This Returns The Full Matched Set For The Fence If Needed
      let setCategory = this.categoryOfFence;
      let setStyle = this.styleOfFence;
      let setColor = this.colorOfFence;
      let setHeight = this.heightOfFence;
      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );
      let filteredForStyle = filteredForCategory.filter(
        (element) => element.style === setStyle
      );
      let filteredForColor = filteredForStyle.filter(
        (element) => element.Color === setColor
      );
      let filteredForHeight = filteredForColor.filter(
        (element) => element.height === setHeight
      );
      return filteredForHeight;
    },
    newestLength: function () {
      var arrayObjectNumber = this.lengths.length;
      var objectNumber = (arrayObjectNumber -= 1);
      var theLength = this.lengths[objectNumber];
      return theLength;
    },
    gateSideIndex: function () {
      var theIndex = parseFloat(this.gateSide.slice(0, 1)) - 1;
      return theIndex;
    },
    fenceStyleForCap: function () {
      let setCategory = "Vinyl";
      let setColor = this.colorOfFence;
      let setHeight = this.heightOfFence;
      let setStyle = this.styleOfFence;

      let filteredForCategory = this.fencePricing.filter(
        (element) => element.Category === setCategory
      );

      if (setColor != "Color" && this.categoryOfFence == "Vinyl") {
        let filtereForStyle = filteredForCategory.filter(
          (element) => element.style === setStyle
        );
        let filteredForColor = filtereForStyle.filter(
          (element) => element.Color === setColor
        );
        let filteredForHeight = filteredForColor.filter(
          (element) => element.height === setHeight
        );
        if (filteredForHeight.length != 0) {
          this.fenceCapStyle.forEach(function (element) {
            if (element["Cap Style"]) {
              element.Cost =
                filteredForHeight[0][element["Cap Style"] + " Our Cost"];
              element.Retail =
                filteredForHeight[0][element["Cap Style"] + " Retail"];
            }
          });
        }
      }

      // get cap styles
      let filteredForCap = this.fenceCapStyle.filter((element) => {
        if (element["Cost"] != 0) {
          return element["Cap Style"];
        }
      });
      filteredForCap.forEach(function (element) {
        element.photo = "./capStyle/" + element["Cap Style"] + ".jpg";
      });
      return filteredForCap;
    },
  },
  methods: {
    getBase64(data) {
      const image = document.createElement("img");

      document.body.appendChild(image);
      image.setAttribute("style", "display:none");
      image.setAttribute("alt", "script div");
      image.setAttribute("src", data);

      const imgCanvas = document.createElement("canvas"),
        imgContext = imgCanvas.getContext("2d");

      // Make sure canvas is as big as the picture
      imgCanvas.width = image.width;
      imgCanvas.height = image.height;

      // Draw image into canvas element
      imgContext.drawImage(image, 0, 0, image.width, image.height);
      // Save image as a data URL
      const imgInfom = imgCanvas.toDataURL("image/jpeg");
      document.body.removeChild(image);

      return imgInfom.replace(/(\r\n|\n|\r)/gm, "");
    },
    async sendPDFtoCustomer() {
      let customerInfo = {
        firstName: this.userData[0].firstName,
        lastName: this.userData[0].lastName,
        content: this.customerPDF,
        toEmail: this.userData[0].emailAddress,
      };

      await emailjs
        .send(
          "service_vl2hbwo",
          "template_zqlmwld",
          customerInfo,
          "wZUpMb9E0cfy_3DVt"
        )
        .then(
          (result) => {
            console.log(result);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    async webhooks() {
      const dateTimeCreated = new Date();

      const gclid = this.randomString();

      this.$gtag.event("submitting", { gclid });

      const data = {
        gclid: gclid,
        dateTimeCreated: JSON.stringify(dateTimeCreated),
        firstName: this.userData[0].firstName,
        lastName: this.userData[0].lastName,
        phoneNumber: this.userData[0].phoneNumber,
        emailAddress: this.userData[0].emailAddress,
        homeAddress: this.userData[0].homeAddress,
        requestName: "V2-Webhooks",
        sender: "sjfencesupply.neltify.app",
      };

      console.log(data)

      try {
        let xhr = new XMLHttpRequest();
        xhr.open(
          "POST",
          "https://hooks.zapier.com/hooks/catch/4955053/3yfza4y?gclid=" + gclid
        );
        xhr.send(JSON.stringify(data));
        console.log("Pushed to Zapier successfully!");
      } catch (e) {
        console.error(e);
      }
    },
    async sendEmailToSJ() {
      // send email to admin:leads@sjfencesupply.com
      let contractorInfoForAdmin = null;

      if (this.customerPDF) {
        contractorInfoForAdmin = {
          firstName: this.userData[0].firstName,
          lastName: this.userData[0].lastName,
          phoneNumber: this.userData[0].phoneNumber,
          emailAddress: this.userData[0].emailAddress,
          homeAddress: this.userData[0].homeAddress,
          content: this.customerPDF,
          toEmail: "leads@sjfencesupply.com",
          companyName: "SJ Fence Supply",
        };
      } else {
        contractorInfoForAdmin = {
          firstName: this.userData[0].firstName,
          lastName: this.userData[0].lastName,
          phoneNumber: this.userData[0].phoneNumber,
          emailAddress: this.userData[0].emailAddress,
          homeAddress: this.userData[0].homeAddress,
          toEmail: "leads@sjfencesupply.com",
          companyName: "SJ Fence Supply",
        };
      }

      await emailjs
        .send(
          "service_vl2hbwo",
          "template_svwmatn",
          contractorInfoForAdmin,
          "wZUpMb9E0cfy_3DVt"
        )
        .then(
          (result) => {
            console.log(result);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    async sendEmail() {
      // send email to all companies in that area
      await Promise.all(
        this.companies.map(async (elem) => {
          let contractorInfo = {
            firstName: this.userData[0].firstName,
            lastName: this.userData[0].lastName,
            phoneNumber: this.userData[0].phoneNumber,
            emailAddress: this.userData[0].emailAddress,
            homeAddress: this.userData[0].homeAddress,
            content: this.customerPDF,
            toEmail: elem.email,
            companyName: elem.name,
          };

          await emailjs
            .send(
              "service_vl2hbwo",
              "template_svwmatn",
              contractorInfo,
              "wZUpMb9E0cfy_3DVt"
            )
            .then(
              (result) => {
                console.log(result);
              },
              (error) => {
                console.log(error);
              }
            );
        })
      );

      this.sendEmailToSJ();
      this.sendPDFtoCustomer();
    },
    randomString() {
      let text = "";
      let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 30; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
    getDistanceBetweenTwoPoints(p1, p2) {
      return Math.floor(
        google.maps.geometry.spherical.computeDistanceBetween(p1, p2) * 3.2808
      );
    },
    getCurrentMousePosition() {
      let currentBounds = map.getBounds();
      let topLeftLatLng = new google.maps.LatLng(
        currentBounds.getNorthEast().lat(),
        currentBounds.getSouthWest().lng()
      );
      let point = map.getProjection().fromLatLngToPoint(topLeftLatLng);

      point.x += event.pageX / (1 << map.getZoom());
      point.y += event.pageY / (1 << map.getZoom());

      point = map.getProjection().fromPointToLatLng(point);

      return point;
    },
    getCurrentTouchPosition() {
      let currentBounds = map.getBounds();
      let topLeftLatLng = new google.maps.LatLng(
        currentBounds.getNorthEast().lat(),
        currentBounds.getSouthWest().lng()
      );
      let point = map.getProjection().fromLatLngToPoint(topLeftLatLng);

      point.x += event.changedTouches[0].pageX / (1 << map.getZoom());
      point.y += event.changedTouches[0].pageY / (1 << map.getZoom());

      point = map.getProjection().fromPointToLatLng(point);

      return point;
    },
    calcDistance(p1, p2) {
      var dx = p2.x - p1.x;
      var dy = p2.y - p1.y;
      return Math.sqrt(dx * dx + dy * dy);
    },
    calcAngle(p1, p2) {
      return (Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180) / Math.PI;
    },
    drawTouch() {
      if (this.isMobile) {
        this.touchIncrement();
      } else {
        this.desktopIncrement();
      }
      this.finishFenceAvailable();
    },
    doneFence() {
      this.fenceAdd = false;
      this.calculateButton = false;
      this.submitForEstimate = true;

      if (this.lengths.length > 0) {
        this.showRemoval = true;
      }
    },
    addFence() {
      this.moveBlocker = false;
      this.showUndo;
      this.counter = 0;
      if (this.isMobile == true) {
        this.sidepanelClass = "sidepanelWithoutBackground z-index-two";
      }
      this.calculateButton = false;
      this.categoryOfFence = "Category";
      this.styleOfFence = "Style";
      this.colorOfFence = "Color";
      this.heightOfFence = "Height";
      this.chooseCategory = null;
      this.chooseStyle = null;
      this.chooseHeight = null;
      this.chooseColor = null;
      this.fenceFormDisabled = 0;
      this.lengths = [];
      this.colorLines = [];
      this.gates = [];
      this.cornersArray = [];
      this.gateSide = "Which Side";
      this.gateStyle = "Gate";
      this.heightOfFenceHolder = "Height";
      this.finishFence = false;
      lengthsFormat();
      this.displayGateAfterLoading = true;

      this.fenceAdd = false;

      drawingManager.setDrawingMode("polyline");
      this.startDrawingFence();
    },
    displayStyleWhenClick() {
      this.chooseStyle = true;
    },
    displayColorWhenClick() {
      // if (this.heightOfFenceHolder != "Height") {
      //   this.chooseColor = true;
      // }
    },
    selectStyleWhenClick() {
      this.chooseStyle = false;
    },
    selectColorWhenClick() {
      this.chooseColor = false;
    },
    deleteSelectedShape() {
      // Removes HTML elements from map showing the last length

      $(".lengthTemp").remove();
      $(".lineTemp").remove();

      var lengthLength = $("#lengthSetter div").length - 1;
      $("#section_" + lengthLength).remove();

      var lineLength = $("#lineSetter div").length - 1;
      $("#line_" + lineLength).remove();

      var cornerLength = $("#cornerSetter div").length - 1;
      $("#corner_" + cornerLength).remove();
      $("#corner_" + (cornerLength - 1)).remove();
      // Removes the last length from the array of lengths
      this.lengths.pop();
      this.colorLines.pop();
      // Removes the corners from the corners array
      this.cornersArray.splice(this.cornersArray.length - 1, 1);
      this.cornersArray.splice(this.cornersArray.length - 2, 1);
      // Removes 1 from amount of corners if the length   made a corner
      if (this.lastSegmentWasACorner == true && this.amountOfCorners > 0) {
        this.amountOfCorners -= 1;
      }
      this.counter -= 2;
      this.newCounter -= 1;
      // Resets button
      // Removes the last line from the map
    },
    lengthFromEndChoosen() {
      this.gateDialog = true;
      if (this.gateExists == false) {
        this.gateDialog = true;
        this.whichDirection = false;
        this.chooseFeetFrom = false;
        this.chooseSide = false;
        this.chooseSideSubTxt = false;
        this.chooseGate = false;
        this.chooseGateQuestion = false;
        var indexNum = this.gateSideIndex;
        var gateSider = this.lengths[indexNum];
        var lengthsArray = JSON.parse(JSON.stringify(this.lengths));
        lengthsArray.splice(this.gateSideIndex, 1);
        lengthsArray.push(this.feetFrom);
        var lengthForLabel = parseFloat(
          (gateSider - this.feetFrom - this.gateWidth).toFixed(2)
        );
        lengthsArray.push(
          parseFloat((gateSider - this.feetFrom - this.gateWidth).toFixed(2))
        );
        this.lengths = lengthsArray;
        document.getElementById("section_" + this.gateSideIndex).innerHTML =
          this.feetFrom +
          "ft" +
          " | " +
          this.gateWidth +
          "' Gate" +
          " | " +
          lengthForLabel +
          "ft";
        this.gateExists = true;
      } else {
        this.gateDialog = true;
        this.whichDirection = false;
        this.chooseFeetFrom = false;
        this.chooseSide = false;
        this.chooseSideSubTxt = false;
        this.chooseGate = false;
        this.chooseGateQuestion = false;
        var gateSider = this.gateSide;
        var newSider = gateSider.slice(3);
        var lengthsArray = JSON.parse(JSON.stringify(this.lengths));
        var newLA = lengthsArray.filter((element) => element != newSider);
        newLA.push(this.feetFrom);
        var newSiderClass = (newSider * 100).toString();
        var theId = document.getElementsByClassName(newSiderClass)[0].id;
        var lengthForLabel = parseFloat(
          (newSider - this.feetFrom - this.gateWidth).toFixed(2)
        );
        document.getElementById(theId).innerHTML =
          this.feetFrom +
          "ft" +
          " | " +
          this.gateWidth +
          "' Gate" +
          " | " +
          lengthForLabel +
          "ft";
        var lastArray = this.lengths.filter((element) => element != newSider);
        lastArray.push(this.feetFrom);
        lastArray.push(lengthForLabel);
        this.lengths = lastArray;
      }
    },
    removalNoCategory() {
      alert("Please select removal Category");
    },
    loadingYes() {
      this.loading = true;
    },
    loadingNo() {
      this.sendEmail();
      this.loading = false;
      this.moveBlocker = false;
      this.showUndo;
      this.counter = 0;
      this.newCounter = 0;
      if (this.isMobile == true) {
        this.sidepanelClass = "sidepanelWithoutBackground z-index-two";
      }
      this.displayGateAfterLoading = true;
      this.categoryOfFence = "Category";
      this.styleOfFence = "Style";
      this.colorOfFence = "Color";
      this.heightOfFence = "Height";
      this.chooseCategory = null;
      this.chooseStyle = null;
      this.chooseHeight = null;
      this.chooseColor = null;
      this.fenceFormDisabled = 0;
      this.lengths = [];
      this.colorLines = [];
      this.gates = [];
      this.cornersArray = [];
      this.gateSide = "Which Side";
      this.gateStyle = "Gate";
      this.heightOfFenceHolder = "Height";
      lengthsFormat();

      this.fenceAdd = false;
      this.submitForEstimate = null;
      this.showRemoval = false;
      this.removalCategory = null;
      this.amountOfRemoval = 0;
      this.amountOfHoles = 0;

      drawingManager.setDrawingMode("polyline");
      this.startDrawingFence();
    },
    starttut() {
      this.userData[0].homeAddress = jQuery("#address").val();
      jQuery(".sidepanel").toggleClass("showSidePanel");
      jQuery(".enteraddress").toggleClass("goaway");
      this.$emit("showPropertyLinesToggle");
      this.$emit("addUsertoUsers");
      this.$emit("blockerGone");
      this.sidepanel = true;
      this.sendEmailToSJ();
      this.webhooks();
    },

    // when desktop
    desktopIncrement() {
      // display corner
      jQuery("<div/>", {
        id: "corner_" + $("#cornerSetter div").length,
        class: "cornerLabel",
      }).appendTo("#cornerSetter");

      var corner = document.getElementById(
        "corner_" + ($("#cornerSetter div").length - 1)
      );

      jQuery(corner).css({
        position: "absolute",
        top: event.pageY,
        left: event.pageX,
        transform: "translate(-4.3px,-4.3px)",
      });

      // increment count
      this.counter += 1;

      // push coordinates of corners
      var cornerTruth = this.cornersArray.map(
        (element) =>
          element.x >= event.pageX - 4 &&
          element.x <= event.pageX + 4 &&
          element.y >= event.pageY - 4 &&
          element.y <= event.pageY + 4
      );
      if (cornerTruth.includes(true)) {
        this.eitherEndsCorner = true;
        this.anotherCounter = true;
        this.amountOfCorners++;
      } else {
        if (this.eitherEndsCorner == true && this.anotherCounter == true) {
          this.lastSegmentWasACorner = true;
          this.anotherCounter = false;
          this.eitherEndsCorner = false;
        }
        this.cornersArray.push({ y: event.pageY, x: event.pageX });
      }

      // when done drawing one fence
      if (this.counter % 2 == 0) {
        this.mouseMove = false;

        drawingManager.setDrawingMode(null);
        drawingManager.setDrawingMode("polyline");

        // get position of current mouse
        let point = this.getCurrentMousePosition();

        let p1 = new google.maps.LatLng(
          this.firstPoint.lat(),
          this.firstPoint.lng()
        );
        let p2 = new google.maps.LatLng(point.lat(), point.lng());

        // get distance between two points
        let realDistance = this.getDistanceBetweenTwoPoints(p1, p2);

        // if realDistance is zero, removing existing shape
        if (realDistance == 0) {
          // Removes HTML elements from map showing the last length
          var lengthLength = $("#lengthSetter div").length - 1;
          $("#section_" + lengthLength).remove();
          var cornerLength = $("#cornerSetter div").length - 1;
          $("#corner_" + cornerLength).remove();
          $("#corner_" + (cornerLength - 1)).remove();

          // Removes the corners from the corners array
          this.cornersArray.splice(this.cornersArray.length - 1, 1);
          // Removes 1 from amount of corners if the length   made a corner
          if (this.lastSegmentWasACorner == true && this.amountOfCorners > 0) {
            this.amountOfCorners -= 1;
          }
        } else {
          this.lengths.push(realDistance);
          this.colorLines.push("line_" + ($("#lengthSetter div").length - 1));

          var length = document.getElementById(
            "section_" + ($("#lengthSetter div").length - 1)
          );
          length.innerHTML = realDistance + " ft";

          this.newCounter++;
          this.showUndoButton = true;
        }

        // add temp section
        jQuery("<div/>", {
          id: "section_" + $("#lengthSetter div").length,
          class: "lengthTemp ",
        }).appendTo("#lengthSetter");

        // add temp line

        jQuery("<div/>", {
          id: "line_" + $("#lineSetter div").length,
          class: "lineTemp",
        }).appendTo("#lineSetter");
      } else {
        // when starting first fence
        this.mouseMove = true;

        this.firstY = event.pageY;
        this.firstX = event.pageX;

        // get position of current mouse

        this.firstPoint = null;
        this.firstPoint = this.getCurrentMousePosition();

        if ($(".lengthTemp").length == 0) {
          // add temp section
          jQuery("<div/>", {
            id: "section_" + $("#lengthSetter div").length,
            class: "lengthTemp ",
          }).appendTo("#lengthSetter");
        }

        if ($(".lineTemp").length == 0) {
          // add temp line
          jQuery("<div/>", {
            id: "line_" + $("#lineSetter div").length,
            class: "lineTemp",
          }).appendTo("#lineSetter");
        }

        // when moving mouse
        addEventListener("mousemove", (e) => {
          if (this.mouseMove == false) return;

          // get position of current mouse
          let point = this.getCurrentMousePosition();

          let p1 = new google.maps.LatLng(
            this.firstPoint.lat(),
            this.firstPoint.lng()
          );
          let p2 = new google.maps.LatLng(point.lat(), point.lng());

          // get distance current drawing fence
          let realDistance = this.getDistanceBetweenTwoPoints(p1, p2);

          // display distance
          let newX = (this.firstX + event.pageX) / 2;
          let newY = (this.firstY + event.pageY) / 2;

          $("#section_" + (Number($("#lengthSetter div").length) - 1)).remove();

          jQuery("<div/>", {
            id: "section_" + $("#lengthSetter div").length,
            class: "lengthLabel " + realDistance * 100,
          }).appendTo("#lengthSetter");
          var length = document.getElementById(
            "section_" + ($("#lengthSetter div").length - 1)
          );
          length.innerHTML = realDistance + " ft";
          jQuery(length).css({
            position: "absolute",
            top: newY,
            left: newX,
          });

          // drawing line
          let selectedPinPos = {
            x: this.firstX,
            y: this.firstY,
          };

          let pinPos = {
            x: event.pageX,
            y: event.pageY,
          };

          let distance = this.calcDistance(selectedPinPos, pinPos);
          let angle = this.calcAngle(selectedPinPos, pinPos);

          $("#line_" + (Number($("#lineSetter div").length) - 1)).remove();

          jQuery("<div/>", {
            id: "line_" + $("#lineSetter div").length,
            class: "lineLabel",
          }).appendTo("#lineSetter");

          let line = document.getElementById(
            "line_" + ($("#lineSetter div").length - 1)
          );

          jQuery(line).css({
            position: "absolute",
            transform: "rotate(" + angle + "deg)",
            width: distance + "px",
            top: selectedPinPos.y,
            left: selectedPinPos.x,
          });

          // done
        });
      }
    },

    // when mobile
    touchIncrement() {
      // display corner
      jQuery("<div/>", {
        id: "corner_" + $("#cornerSetter div").length,
        class: "cornerLabel",
      }).appendTo("#cornerSetter");

      var corner = document.getElementById(
        "corner_" + ($("#cornerSetter div").length - 1)
      );

      jQuery(corner).css({
        position: "absolute",
        top: event.changedTouches[0].pageY,
        left: event.changedTouches[0].pageX,
        transform: "translate(-4.3px,-4.3px)",
      });

      // increment count
      this.counter += 1;

      // push coordinates of corners
      var cornerTruth = this.cornersArray.map(
        (element) =>
          element.x >= event.changedTouches[0].pageX - 4 &&
          element.x <= event.changedTouches[0].pageX + 4 &&
          element.y >= event.changedTouches[0].pageY - 4 &&
          element.y <= event.changedTouches[0].pageY + 4
      );
      if (cornerTruth.includes(true)) {
        this.eitherEndsCorner = true;
        this.anotherCounter = true;
        this.amountOfCorners++;
      } else {
        if (this.eitherEndsCorner == true && this.anotherCounter == true) {
          this.lastSegmentWasACorner = true;
          this.anotherCounter = false;
          this.eitherEndsCorner = false;
        }
        this.cornersArray.push({
          y: event.changedTouches[0].pageY,
          x: event.changedTouches[0].pageX,
        });
      }

      // when done drawing one fence
      if (this.counter % 2 == 0) {
        this.mouseMove = false;

        drawingManager.setDrawingMode(null);
        drawingManager.setDrawingMode("polyline");

        // get position of current touch getCurrentTouchPosition
        let point = this.getCurrentTouchPosition();

        let p1 = new google.maps.LatLng(
          this.firstPoint.lat(),
          this.firstPoint.lng()
        );
        let p2 = new google.maps.LatLng(point.lat(), point.lng());

        // get distance between two points
        let realDistance = this.getDistanceBetweenTwoPoints(p1, p2);
        // if realDistance is zero, removing existing shape
        if (realDistance == 0) {
          // Removes HTML elements from map showing the last length
          var lengthLength = $("#lengthSetter div").length - 1;
          $("#section_" + lengthLength).remove();
          var cornerLength = $("#cornerSetter div").length - 1;
          $("#corner_" + cornerLength).remove();
          $("#corner_" + (cornerLength - 1)).remove();

          // Removes the corners from the corners array
          this.cornersArray.splice(this.cornersArray.length - 1, 1);
          // Removes 1 from amount of corners if the length   made a corner
          if (this.lastSegmentWasACorner == true && this.amountOfCorners > 0) {
            this.amountOfCorners -= 1;
          }
        } else {
          this.lengths.push(realDistance);
          this.colorLines.push("line_" + ($("#lengthSetter div").length - 1));

          var length = document.getElementById(
            "section_" + ($("#lengthSetter div").length - 1)
          );
          length.innerHTML = realDistance + " ft";

          this.newCounter++;
          this.showUndoButton = true;
        }

        // add temp section
        jQuery("<div/>", {
          id: "section_" + $("#lengthSetter div").length,
          class: "lengthTemp ",
        }).appendTo("#lengthSetter");

        // add temp line

        jQuery("<div/>", {
          id: "line_" + $("#lineSetter div").length,
          class: "lineTemp",
        }).appendTo("#lineSetter");
      } else {
        this.mouseMove = true;

        this.firstY = event.changedTouches[0].pageY;
        this.firstX = event.changedTouches[0].pageX;

        // get position of current touch
        let point = this.getCurrentTouchPosition();

        this.firstPoint = null;
        this.firstPoint = point;

        if ($(".lengthTemp").length == 0) {
          // add temp section
          jQuery("<div/>", {
            id: "section_" + $("#lengthSetter div").length,
            class: "lengthTemp ",
          }).appendTo("#lengthSetter");
        }

        if ($(".lineTemp").length == 0) {
          // add temp line
          jQuery("<div/>", {
            id: "line_" + $("#lineSetter div").length,
            class: "lineTemp",
          }).appendTo("#lineSetter");
        }

        addEventListener("touchmove", (e) => {
          if (this.mouseMove == false) return;

          // get position of current touch
          let point = this.getCurrentTouchPosition();

          let p1 = new google.maps.LatLng(
            this.firstPoint.lat(),
            this.firstPoint.lng()
          );
          let p2 = new google.maps.LatLng(point.lat(), point.lng());

          // get distance between two points
          let realDistance = this.getDistanceBetweenTwoPoints(p1, p2);

          // display div
          let newX = (this.firstX + event.changedTouches[0].pageX) / 2;
          let newY = (this.firstY + event.changedTouches[0].pageY) / 2;

          $("#section_" + (Number($("#lengthSetter div").length) - 1)).remove();

          jQuery("<div/>", {
            id: "section_" + $("#lengthSetter div").length,
            class: "lengthLabel " + realDistance * 100,
          }).appendTo("#lengthSetter");
          var length = document.getElementById(
            "section_" + ($("#lengthSetter div").length - 1)
          );
          length.innerHTML = realDistance + " ft";
          jQuery(length).css({
            position: "absolute",
            top: newY,
            left: newX,
          });

          // drawing line
          let selectedPinPos = {
            x: this.firstX,
            y: this.firstY,
          };

          let pinPos = {
            x: event.changedTouches[0].pageX,
            y: event.changedTouches[0].pageY,
          };

          let distance = this.calcDistance(selectedPinPos, pinPos);
          let angle = this.calcAngle(selectedPinPos, pinPos);

          $("#line_" + (Number($("#lineSetter div").length) - 1)).remove();

          jQuery("<div/>", {
            id: "line_" + $("#lineSetter div").length,
            class: "lineLabel",
          }).appendTo("#lineSetter");

          let line = document.getElementById(
            "line_" + ($("#lineSetter div").length - 1)
          );

          jQuery(line).css({
            position: "absolute",
            transform: "rotate(" + angle + "deg)",
            width: distance + "px",
            top: selectedPinPos.y,
            left: selectedPinPos.x,
          });
        });
      }
    },
    finishFenceAvailable() {
      if (this.counter == 2) {
        this.finishVis = true;
      }
    },
    makeAGate() {
      this.chooseGate = true;
      this.chooseGateQuestion = false;
    },
    noGate() {
      var finalLengths = this.lengths.filter((element) => element != 0);
      this.lengths = finalLengths;
      this.fenceAdd = true;
      this.calculateButton = true;
      this.chooseGateQuestion = false;

      drawingManager.setDrawingMode(null);
    },
    startDrawingFence() {
      map.setOptions({ disableDefaultUI: true });
      map.setOptions({ draggable: false });
      map.setOptions({ backgroundColor: "none" });
      this.moveVis = false;
      this.moveBlocker = false;
      this.showUndo;
      document.getElementById("tutorialstep").innerHTML =
        "Drag to draw your fence";
    },
    finishFenceSwitch() {
      this.chooseCategory = true;
      this.finishVis = false;
      this.moveBlocker = true;
      this.showUndoButton = false;

      this.sidepanelClass = "sidepanel z-index-two";
      if ((this.finishFence = true)) {
        document.getElementById("tutorialstep").innerHTML =
          "Select your fence style";
      }
      drawingManager.setDrawingMode(null);
    },
    chooseGateAble() {
      document.querySelectorAll("disableFormFence").disabled = true;
    },
    disableButton() {
      this.buttonIsntActive = 1;
    },
    finishGate() {
      var finalLengths = this.lengths.filter((element) => element != 0);
      this.lengths = finalLengths;
      this.fenceAdd = true;
      this.calculateButton = true;
      this.chooseGateQuestion = false;
      this.chooseGate = false;
      this.chooseSide = false;
      this.chooseFeetFrom = false;
      this.whichDirection = false;
      this.gateDialog = false;
      this.gates.push(this.gateStyle);

      drawingManager.setDrawingMode(null);
    },
    addAnotherGate() {
      this.chooseGate = true;
      this.chooseGateQuestion = false;
      this.chooseSide = false;
      this.chooseFeetFrom = false;
      this.whichDirection = false;
      this.gateDialog = false;
      this.gates.push(this.gateStyle);
      this.gateStyle = "Gate";
      this.gateFromSide = "From Which End";
      this.gateSide = "Which Side";
      this.feetFrom = 0;
    },
    didNotFallOff() {
      this.$emit("didNotFallOff");
    },
    amountOfRemovalAll() {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;

      let sum = 0;
      for (const key in this.multiFences) {
        sum += this.multiFences[key].lengths.reduce(reducer);
      }

      this.amountOfRemoval = sum;
    },
  },
};

// setting the data of "lengths" to what google maps outputs on each line drawn part 1
var result = 0;
var resultstore = [];

var lengthsFormat = function () {
  result = 0;
  resultstore = [];
};

var example = function () {
  return resultstore;
};
// setting the data of "lengths" to what google maps outputs on each line drawn part 1

// Google Map Start
var drawingManager;
var selectedShape;
var map;
var newShape;

function initMap() {
  var colors = ["#FF1493"];
  var selectedColor;
  var colorButtons = {};
  var Jersey = { lat: 40.07617, lng: -74.71145 };

  map = new google.maps.Map(document.getElementById("googleMap"), {
    zoom: 32,
    geodesic: true,
    center: Jersey,
    mapTypeId: google.maps.MapTypeId.HYBRID,
    disableDefaultUI: false,
    zoomControl: true,
    scrollwheel: true,
    draggable: true,
    fullscreenControl: false,
    backgroundColor: "",
  });
  map.setTilt(0);

  function clearSelection() {
    if (selectedShape) {
      selectedShape.setEditable(false);
      selectedShape = null;
    }
  }

  function selectColor(color) {
    selectedColor = color;
    for (var i = 0; i < colors.length; ++i) {
      var currColor = colors[i];
      colorButtons[currColor].style.border =
        currColor == color ? "2px solid #789" : "2px solid #fff";
    }

    // Retrieves the current options from the drawing manager and replaces the
    // stroke or fill color as appropriate.
    var polylineOptions = drawingManager.get("polylineOptions");
    polylineOptions.strokeColor = color;
    drawingManager.set("polylineOptions", polylineOptions);
  }

  function setSelectedShapeColor(color) {
    if (selectedShape) {
      if (selectedShape.type == google.maps.drawing.OverlayType.POLYLINE) {
        selectedShape.set("strokeColor", color);
      } else {
        selectedShape.set("fillColor", color);
      }
    }
  }

  function deleteSelectedShape() {
    if (selectedShape) {
      selectedShape.setMap(null);
    }
  }

  function makeColorButton(color) {
    var button = document.createElement("span");
    button.className = "color-button";
    button.style.backgroundColor = color;
    google.maps.event.addDomListener(button, "click", function () {
      selectColor(color);
      setSelectedShapeColor(color);
    });

    return button;
  }

  var polyOptions = {
    strokeColor: "#ffff00",
    strokeWeight: 3,
    fillOpacity: 0.45,
    editable: false,
    geodesic: true,
    clickable: true,
  };

  // Creates a drawing manager attached to the map that allows the user to draw
  // markers, lines, and shapes.
  drawingManager = new google.maps.drawing.DrawingManager({
    drawingMode: google.maps.drawing.OverlayType.POLYLINE,
    drawingControl: true,
    drawingControlOptions: {
      position: google.maps.ControlPosition.TOP_CENTER,
      drawingModes: ["polyline", "null"],
    },
    markerOptions: {
      draggable: true,
    },
    polylineOptions: polyOptions,
    rectangleOptions: polyOptions,
    circleOptions: polyOptions,
    polygonOptions: polyOptions,
    map: map,
  });

  // Google Map End

  // Google Geocoder Start

  var geocoder = new google.maps.Geocoder();
  var input = document.getElementById("address");
  new google.maps.places.Autocomplete(input);

  document
    .getElementById("submitaddress")
    .addEventListener("click", function () {
      $(".floating-panel").removeClass("formadd");
      setTimeout(function () {
        $(".floating-panel").addClass("goaway");
      }, 200);
      geocodeAddress(geocoder, map);
      map.setZoom(32);
    });

  google.maps.event.addDomListener(window, "load", initMap);

  function geocodeAddress(geocoder, resultsMap) {
    var address = document.getElementById("address").value;
    geocoder.geocode({ address: address }, function (results, status) {
      if (status === "OK") {
        resultsMap.setCenter(results[0].geometry.location);
        var marker = new google.maps.Marker({
          map: resultsMap,
          position: results[0].geometry.location,
        });

        setTimeout(function () {
          map.setZoom(32);
        }, 1000);
      } else {
        alert("Geocode was not successful for the following reason: " + status);
      }
    });
  }

  google.maps.event.addListener(
    drawingManager,
    "overlaycomplete",
    function (e) {
      // Add an event listener that selects the newly-drawn shape when the user
      // mouses down on it.
      newShape = e.overlay;
      newShape.type = e.type;
      google.maps.event.addListener(newShape, "click", function () {
        setSelection(newShape);
      });

      var length = google.maps.geometry.spherical.computeLength(
        newShape.getPath()
      );

      var lengthdone = Math.ceil(length * 3.28084);
      // convert length to string
      var str_a = lengthdone.toFixed(2);
      // and back
      result = Number(str_a);
      // setting the data of "lengths" to what google maps outputs on each line drawn part 2
      resultstore.push(result);

      // setting the data of "lengths" to what google maps outputs on each line drawn part 2
    }
  );

  var zoom = map.getZoom();
  $(".zoomIn").click(function () {
    if (zoom == 32) {
    } else if (zoom == 20) {
      zoom = 32;
      map.setZoom(zoom);
    } else if (zoom < 20) {
      zoom = zoom + 0.1;
      map.setZoom(zoom);
    }
  });
  $(".zoomOut").click(function () {
    if (zoom == 32) {
      zoom = 19.9;
      map.setZoom(zoom);
    } else if (zoom <= 20) {
      zoom = zoom - 0.1;
      map.setZoom(zoom);
    }
  });

  $(".undobutton").click(function () {
    newShape.setMap(null);
  });

  // Map Nav Arrows
  $(".up").click(function () {
    var cen = map.getCenter();
    var lat1 = cen.lat();
    var lng1 = cen.lng();
    var newCord = {
      lat: lat1 + 0.00001,
      lng: lng1,
    };
    map.setCenter(newCord);
    map.setZoom(zoom);
  });
  $(".down").click(function () {
    var cen = map.getCenter();
    var lat1 = cen.lat();
    var lng1 = cen.lng();
    var newCord = {
      lat: lat1 - 0.00001,
      lng: lng1,
    };
    map.setCenter(newCord);
    map.setZoom(zoom);
  });
  $(".left").click(function () {
    var cen = map.getCenter();
    var lat1 = cen.lat();
    var lng1 = cen.lng();
    var newCord = {
      lat: lat1,
      lng: lng1 - 0.00001,
    };
    map.setCenter(newCord);
    map.setZoom(zoom);
  });
  $(".right").click(function () {
    var cen = map.getCenter();
    var lat1 = cen.lat();
    var lng1 = cen.lng();
    var newCord = {
      lat: lat1,
      lng: lng1 + 0.00001,
    };
    map.setCenter(newCord);
    map.setZoom(zoom);
  });
}
var proplineholder;
function showPropLines() {
  proplineholder = REP.Layer.Google.Initialize(map, {
    Return_Buildings: false,
  });
}

function hidePropLines() {
  map.overlayMapTypes.pop();
}
</script>

<style>
.imgForPdf {
  position: absolute;
  z-index: -1;
  top: 0px;
  left: -10000px;
}

select {
  width: 90%;
  height: 30px !important;
  margin-bottom: 5px !important;
  border: 1px solid #7e7e7e;
  border-radius: 3px;
}

.topMarg {
  margin-top: 10px !important;
}

.mapcontainer,
.googleMap {
  height: 100vh;
  display: block;
  padding: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  overflow: visible !important;
}

#googleMap > div > div > div:nth-child(3) {
  opacity: 0;
}

.gm-style-cc,
.gmnoprint {
  display: none !important;
}

.googleMap {
  width: 100vw;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

/*
.googlemapslide{
  width: calc(100vw - 300px) !important;
}
*/

.googleMap,
.sidepanel {
  float: left;
}

.mapcontainer {
  width: 100vw;
}

.sidepanel {
  position: absolute;
  display: block;
  overflow-y: scroll !important;
  right: 6px;
  top: 6px;
  width: 300px;
  background-color: white;
  height: 98vh;
  max-height: 100vh;
  border-radius: 10px !important;
  box-shadow: 0 20px 10px -10px rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  -webkit-overflow-scrolling: touch;
}

.sidepanelWithoutBackground {
  position: absolute;
  display: block;
  overflow-y: scroll !important;
  right: 6px;
  top: 6px;
  width: 300px;
  max-height: 100vh;
  border-radius: 10px !important;
  box-shadow: 0 20px 10px -10px rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

#floating-panel {
  position: absolute;
  max-width: 320px;
  top: 10px;
  background-color: white;
  border-radius: 10px;
  padding: 20px 40px !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  z-index: 10;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.fph3 {
  padding-bottom: 10px !important;
}

.tutorialstep {
  padding: 30px 0px 6px 0px !important;
  background-color: #2573c2;
  color: #ffffff;
  border-radius: 8px 8px 2px 2px;
  margin: 3px auto !important;
  width: 98%;
}

button.buttonIsntActive {
  font-family: sofia-pro, sans-serif;
  font-size: 16px !important;
  margin-top: 20px !important;
  width: auto;
  height: auto;
  border: none;
  border-radius: 5px;
  background-color: rgba(37, 115, 193, 0.5) !important;
  color: rgba(255, 255, 255, 0.5);
  padding: 8px 40px 10px 40px !important;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  cursor: initial !important;
}

.lengthLabel {
  z-index: 2;
  padding: 6px 10px !important;
  font-size: 15px !important;
  border-radius: 0px 4px 4px 4px !important;
  background-color: rgba(40, 122, 204, 0.5);
  color: white;
  pointer-events: none !important;
}

.cornerLabel {
  width: 5px;
  height: 5px;
  background-color: rgba(37, 115, 193, 1);
  border: 2px solid white;
  border-radius: 100px;
  pointer-events: none;
  z-index: 2;
}

.lineLabel {
  z-index: 1;
  width: 3px;
  height: 3px;
  background-color: yellow;
  pointer-events: none;
  transform-origin: 0% 0%;
}

.cornerLabel:hover {
  background-color: rgba(37, 115, 193, 1);
  border: 2px solid rgb(199, 199, 199);
}

#feetFrom {
  width: 83%;
  border: 1px solid grey;
  font-size: 12px !important;
  background-color: rgb(248, 248, 248);
  height: 10px;
}

.holesToolTip {
  text-align: left;
  float: left;
  position: relative;
  top: -180px;
  left: -12px;
  width: 200px;
  background-color: rgba(37, 115, 193, 1);
  color: white;
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.4);
  padding: 20px !important;
  border-radius: 5px;
}

.holesToolTip::after {
  content: "";
  position: relative;
  bottom: -52px;
  left: 0%;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid rgba(37, 115, 193, 1);
}

.fenceStyleWrapperWrap {
  margin: 0px auto !important;
  display: block;
  width: 92% !important;
  height: 100px;
  text-align: center;
}

label.fenceStyleLabel {
  font-size: 14px;
  margin-top: -22px !important;
  padding-top: 10px !important;
  width: 100% !important;
  display: block;
  min-height: 130px;
}

.fenceStyleWrapper {
  border-radius: 2px;
  border: 1px solid #232323;
  margin: 0px 5px !important;
  margin-bottom: 10px !important;
  float: left;
  width: 42%;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  box-sizing: border-box !important;
}

.fenceStyleWrapper:hover {
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 2px rgba(37, 115, 193, 1),
    0 8px 6px -6px rgba(0, 0, 0, 0.4);
}

.fenceStylePhoto {
  width: 90%;
}

.padWrapper {
  position: absolute;
  right: 350px;
  bottom: 50px;
}

.centerCircle {
  height: 20px;
  width: 20px;
  display: block;
  position: relative;
  top: 0px;
  left: 5px;
  background-color: #2196f3;
  border-radius: 40px;
}

.right {
  top: 85px;
  left: 30px;
}

.down {
  top: 85px;
}

.up {
  top: 85px;
}

.left {
  top: 25px;
  transform: rotate(180deg);
  left: -30px;
}

.d-pad img {
  position: relative;
  display: block;
  width: 20px;
  height: 20px;
  text-decoration: none;
  background-color: #2196f3;
  color: white;
  padding: 5px !important;
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition: all 0.1s ease-out;
  -moz-transition: all 0.1s ease-out;
  -o-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
}

.d-pad img:hover {
  background-color: #1a85dc;
}

img.down {
  transform: rotate(90deg);
}

img.up {
  transform: rotate(-90deg);
}

.zoomPadWrapper {
  position: absolute;
  right: 430px;
  bottom: 35px;
}

.zoomOut {
  top: 10px;
}

.zoomIn {
  top: 0px;
}

.zoom-pad img,
.zoom-pad div {
  position: relative;
  display: block;
  width: 20px;
  height: 20px;
  text-decoration: none;
  background-color: #2196f3;
  color: white;
  padding: 5px !important;
  border-radius: 100px;
  cursor: pointer;
  -webkit-transition: all 0.1s ease-out;
  -moz-transition: all 0.1s ease-out;
  -o-transition: all 0.1s ease-out;
  transition: all 0.1s ease-out;
}

.zoom-pad div {
  font-size: 20px;
}

.zoom-pad div {
  background-color: #1a85dc;
  padding: 0px 5px 10px 5px !important;
  font-size: 40px;
  line-height: 27px;
  font-weight: 100 !important;
}

.moveBlocker {
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  background-color: transparent;
  z-index: 1;
}

.blankScreen {
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  background-color: transparent;
  z-index: 1;
}

.z-index-two {
  z-index: 2;
}

.UndoWrapper {
  position: absolute;
  left: 280px;
  top: 0px;
}

.undobutton {
  z-index: 20;
  font-size: 12px !important;
  padding: 8px 20px !important;
  border-radius: 1px;
}

.removalButton {
  padding: 6px 10px 8px 10px !important;
  margin-right: 10px !important;
  width: 20% !important;
}

.loading-txt {
  margin-top: 40px !important;
  font-weight: 600;
}

.removalInput {
  margin-top: 30px !important;
}

#menu__toggle {
  opacity: 0;
}

#menu__toggle:not(:checked) + .menu__btn > span {
  transform: rotate(45deg);
}

#menu__toggle:not(:checked) + .menu__btn > span::before {
  top: 0;
  transform: rotate(0deg);
}

#menu__toggle:not(:checked) + .menu__btn > span::after {
  top: 0;
  transform: rotate(90deg);
}

#menu__toggle:not(:checked) ~ .menu__box {
  right: 6px !important;
}

.menu__btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 26px;
  height: 26px;
  cursor: pointer;
  z-index: 5;
}

.menu__btn > span,
.menu__btn > span::before,
.menu__btn > span::after {
  display: block;
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: red;
  transition-duration: 0.25s;
}

.menu__btn > span::before {
  content: "";
  top: -8px;
}

.menu__btn > span::after {
  content: "";
  top: 8px;
}

.menu__box {
  position: fixed;
  display: block;
  overflow-y: scroll !important;
  top: 6px;
  right: -100%;
  width: 300px;
  height: 98vh;
  max-height: 100vh;
  border-radius: 10px !important;
  background-color: white;
  box-shadow: 0 20px 10px -10px rgba(0, 0, 0, 0.5);
  transition-duration: 0.25s;
}

.menu__item {
  display: block;
  padding: 12px 24px;
  color: #333;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: 600;
  text-decoration: none;
  transition-duration: 0.25s;
}

.menu__item:hover {
  background-color: #cfd8dc;
}

#htmltocanvas {
  width: 100%;
  height: 100%;
}
</style>
